<app-modal title="Delete Specific Trading Time" #modalComponent>
  <div class="confirmation-text">
    Do you really want to delete specific trading time for<br>
    {{ date() }}?
  </div>
  <div class="mt-4 text-end">
    <button class="btn btn-primary-outline btn-form me-3" type="button" (click)="modalComponent.activeModal.close()">
      Close
    </button>
    <button class="btn btn-danger btn-form" type="button" (click)="confirm(modalComponent)" [disabled]="loading()">
      Delete
    </button>
  </div>
</app-modal>